import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  filter: drop-shadow(0px 4px 25px rgba(0, 0, 0, 0.12));
  background-color: #fff;
`;
